module.exports = "<app-project-starter (addProject)=\"addProject($event)\"></app-project-starter>\n"